import { AlertEvent } from './types';

export type OpenFault = AlertEvent & {
  acknowledged: boolean;
  acknowledgedAt: number | null;
};

export function isAlarmSide(side: AlertEvent['side']): boolean {
  return side === 'high' || side === 'low' || side === 'on';
}

/** Latest alarm per rule. An ack counts only when it is newer than that alarm. */
export function openFaults(events: AlertEvent[]): OpenFault[] {
  const sorted = [...events]
    .filter((event) => event.ruleId)
    .sort((a, b) => b.at - a.at);
  const byRule: Record<string, { event: AlertEvent | null; ack: AlertEvent | null }> = {};
  for (const event of sorted) {
    const ruleId = event.ruleId;
    let slot = byRule[ruleId];
    if (!slot) {
      slot = { event: null, ack: null };
      byRule[ruleId] = slot;
    }
    if (event.kind === 'ack') {
      if (!slot.event && !slot.ack) {
        slot.ack = event;
      }
      continue;
    }
    if (!slot.event) {
      slot.event = event;
    }
  }
  const open: OpenFault[] = [];
  for (const ruleId of Object.keys(byRule)) {
    const slot = byRule[ruleId];
    if (!slot.event || !isAlarmSide(slot.event.side)) {
      continue;
    }
    open.push({
      ...slot.event,
      ruleId,
      acknowledged: Boolean(slot.ack),
      acknowledgedAt: slot.ack ? slot.ack.at : null,
    });
  }
  open.sort((a, b) => b.at - a.at);
  return open;
}
